import { render, staticRenderFns } from "./compositionBOD.vue?vue&type=template&id=188173d8&scoped=true&"
import script from "./compositionBOD.vue?vue&type=script&lang=js&"
export * from "./compositionBOD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188173d8",
  null
  
)

export default component.exports